export const endpoints = {
  auth: {
    me: '/auth/admin/me',
    login: '/auth/admin/login',
    logout: '/auth/admin/logout',
    refresh: '/auth/admin/refresh',
    otpSend: '/auth/admin/login/otp/send',
    otpVerify: '/auth/admin/login/otp/verify',
    forgotSend: '/auth/admin/forgot-password/send',
    forgotVerify: '/auth/admin/forgot-password/verify',
    forgotReset: '/auth/admin/forgot-password/reset',
  },
  products: {
    categories: '/products/admin/categories',
    categoriesExport: '/products/admin/categories/export',
    components: '/products/admin/components',
    componentsExport: '/products/admin/components/export',
    metaCategories: '/products/admin/meta/categories',
    devices: '/products/admin/devices',
    devicesExport: '/products/admin/devices/export',
    metaComponents: '/products/admin/meta/components',
    bundles: '/products/admin/bundles',
    bundlesExport: '/products/admin/bundles/export',
    metaDevices: '/products/admin/meta/devices',
  },
  orders: {
    list: '/orders/admin/orders',
    export: '/orders/admin/orders/export',
    metaCities: '/orders/admin/meta/cities',
    metaCustomers: '/orders/admin/meta/customers',
    detail: (id: string) => `/orders/admin/orders/${id}`,
    status: (id: string) => `/orders/admin/orders/${id}/status`,
    expectedDelivery: (id: string) => `/orders/admin/orders/${id}/expected-delivery`,
    cancel: (id: string) => `/orders/admin/orders/${id}/cancel`,
    invoice: (id: string) => `/orders/admin/orders/${id}/invoice`,
    reviews: (id: string) => `/orders/admin/orders/${id}/reviews`,
    tickets: (id: string) => `/orders/admin/orders/${id}/tickets`,
    replacements: (id: string) => `/orders/admin/orders/${id}/replacements`,
    parameters: (id: string) => `/orders/admin/orders/${id}/parameters`,
    metaAssignees: '/orders/admin/meta/assignees',
    metaParameterTemplates: '/orders/admin/meta/parameter-templates',
  },
  customers: {
    list: '/customers/admin/customers',
    export: '/customers/admin/customers/export',
    catalog: '/customers/admin/meta/catalog',
  },
  customerDetail: {
    orders: '/customers/admin/detail/orders',
    devices: '/customers/admin/detail/devices',
    alerts: '/customers/admin/detail/device-alerts',
    subscriptions: '/customers/admin/detail/subscriptions',
    subscriptionTimeline: '/customers/admin/detail/subscription-timeline',
    orderSupport: '/customers/admin/detail/order-support',
    deviceSupport: '/customers/admin/detail/device-support',
    activity: '/customers/admin/detail/activity-log',
    meta: '/customers/admin/detail/meta',
    tickets: '/customers/admin/detail/tickets',
  },
  reports: {
    orders: '/reports/admin/orders',
    devices: '/reports/admin/devices',
    deviceActivity: '/reports/admin/device-activity',
    customerUsage: '/reports/admin/customer-usage',
    subscription: '/reports/admin/subscription',
    meta: '/reports/admin/meta',
    export: '/reports/admin/export',
  },
  payments: {
    list: '/payments/admin/payments',
    export: '/payments/admin/payments/export',
    timeline: '/payments/admin/payments/timeline',
  },
  notifications: {
    list: '/notifications/admin/notifications',
    readAll: '/notifications/admin/notifications/read-all',
    read: (id: string) => `/notifications/admin/notifications/${id}/read`,
  },
  dashboard: {
    summary: '/dashboard/admin/summary',
    chart: '/dashboard/admin/chart',
    installations: '/dashboard/admin/installations',
    replacements: '/dashboard/admin/replacements',
    orderTickets: '/dashboard/admin/order-tickets',
    deviceTickets: '/dashboard/admin/device-tickets',
    action: (id: string) => `/dashboard/admin/requests/${id}/action`,
  },
  support: {
    orders: '/support/admin/orders',
    devices: '/support/admin/devices',
    export: '/support/admin/export',
    employees: '/support/admin/meta/employees',
    raise: '/support/admin/tickets',
    detail: (id: string) => `/support/admin/tickets/${id}`,
    messages: (id: string) => `/support/admin/tickets/${id}/messages`,
    assign: (id: string) => `/support/admin/tickets/${id}/assign`,
    close: (id: string) => `/support/admin/tickets/${id}/close`,
  },
  requests: {
    installations: '/requests/admin/installations',
    replacements: '/requests/admin/replacements',
    warranty: '/requests/admin/warranty',
    export: '/requests/admin/export',
    employees: '/requests/admin/meta/employees',
    installationDetail: (id: string) => `/requests/admin/installations/${id}`,
    replacementDetail: (id: string) => `/requests/admin/replacements/${id}`,
    warrantyDetail: (id: string) => `/requests/admin/warranty/${id}`,
    approve: (type: string, id: string) => `/requests/admin/${type}/${id}/approve`,
    reject: (type: string, id: string) => `/requests/admin/${type}/${id}/reject`,
  },
  discounts: {
    list: '/discounts/admin/discounts',
    export: '/discounts/admin/discounts/export',
    catalog: '/discounts/admin/meta/catalog',
    customers: '/discounts/admin/detail/customers',
    devices: '/discounts/admin/detail/devices',
  },
  activityLog: {
    list: '/activity-log/admin/logs',
    export: '/activity-log/admin/logs/export',
    meta: '/activity-log/admin/meta',
  },
  customerMap: {
    fields: '/customers/admin/map/fields',
    equipment: '/customers/admin/map/equipment',
    wells: '/customers/admin/map/wells',
    availableEquipment: '/customers/admin/map/available-equipment',
    availablePumps: '/customers/admin/map/available-pumps',
    deviceActivity: '/customers/admin/map/device-activity',
  },
  users: {
    adminInternal: '/users/admin/internal-users',
    adminInternalExport: '/users/admin/internal-users/export',
    adminDealers: '/users/admin/dealers',
    dealerCities: '/users/admin/dealers/meta/cities',
  },
  storage: {
    presignedUrl: '/storage/admin/pre-signed-url',
  },
} as const;
